import { View } from "react-native";
import React from "react";
import type { ReactNode } from "react";

type Props = {
  readonly children: ReactNode;
};

export const CenteredContent = ({ children }: Props) => (
  <View style={{ alignItems: "center", flex: 1, justifyContent: "center" }}>{children}</View>
);
